export const FittingsFilterData = [
    {
        "idFromColumnFilter": "name",
        "id": "name",
    },
    {
        "idFromColumnFilter": "quantity",
        "id": "quantity",
    },
]